import { classNames } from "../styles/classNames";

interface SpinnerIconProps {
  className?: string;
}

export default function SpinnerIcon({ className }: SpinnerIconProps) {
  return (
    <svg className={classNames("h-4 w-4 animate-spin", className)} viewBox="0 0 24 24" aria-hidden="true">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}
